import { render } from "./Logistics.vue?vue&type=template&id=6edc2f46&scoped=true"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"

import "./Logistics.vue?vue&type=style&index=0&id=6edc2f46&lang=scss"
import "./Logistics.vue?vue&type=style&index=1&id=6edc2f46&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edc2f46"]])

export default __exports__